import Swiper, { Pagination, EffectFade } from 'swiper'

Swiper.use([Pagination, EffectFade])

new Swiper('.js-topBannerSlider.swiper-container', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  direction: 'vertical',
  pagination: {
    el: '.js-topBannerSlider .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
})

if ($('.js-topBanner').length > 0) {
  $('body').addClass('page_has_top_banner')
}

$('.js-topBannerClose').on('click', () => {
  $('.js-topBanner').remove()
  $('body').removeClass('page_has_top_banner')
})
